export interface Shipment {
    id: number;
    type: string;
  };

export var displayColumns = [
  'type'
]
export var displayHeaders = [
  'Type'
]
// actual database columns
export var orderByColumns = [
  'type'
]

// for dropdown the options are set via ts file, so modify the code there
export const filterParameters = [
  { 
      name: 'created_at', 
      type: 'date_range', 
      operator: 'between', 
      label: 'Select Date Range' 
  },
  { 
      name: 'type', 
      type: 'string', 
      operator: 'like', 
      label: 'Type', 
  },
  { 
    name: 'order_by_columns', 
    type: 'multi_select', 
    operator: 'order_by_columns',
    values: displayHeaders.map((header, index) => ({
            label: header,
            value: orderByColumns[index]
        })),
    model_name:'shipment',
    label: 'Select columns for order by' 
  }
]; 
